export default __webpack_public_path__ + "static/media/lazy-load.05387b56.svg";